import { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebaseConfig';
import { useNavigate } from 'react-router-dom'; // useNavigate ইমপোর্ট করলাম

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate(); // হুকটি ব্যবহার করলাম

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      localStorage.setItem("isAdminLoggedIn", "true");
      navigate('/admin'); 
    } catch (error) {
      alert("লগইন ব্যর্থ: সঠিক ইমেইল ও পাসওয়ার্ড দিন");
    }
  };

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      minHeight: '100vh',
      backgroundColor: '#f4f4f4' 
    }}>
      <div style={{ 
        padding: '30px', 
        backgroundColor: '#fff', 
        borderRadius: '8px', 
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        width: '300px'
      }}>
        <h2 style={{ textAlign: 'center', color: '#d2202a' }}>অ্যাডমিন লগইন</h2>
        <form onSubmit={handleLogin}>
          <input 
            type="email" 
            placeholder="ইমেইল" 
            onChange={(e) => setEmail(e.target.value)} 
            style={{ width: '100%', padding: '10px', marginBottom: '10px', boxSizing: 'border-box' }}
          /><br />
          <input 
            type="password" 
            placeholder="পাসওয়ার্ড" 
            onChange={(e) => setPassword(e.target.value)} 
            style={{ width: '100%', padding: '10px', marginBottom: '20px', boxSizing: 'border-box' }}
          /><br />
          <button 
  type="submit" 
  onMouseEnter={(e) => e.target.style.backgroundColor = '#b01c24'}
  onMouseLeave={(e) => e.target.style.backgroundColor = '#555'}
  style={{ 
    width: '100%', 
    padding: '10px', 
    backgroundColor: '#d2202a', 
    color: '#fff', 
    border: 'none', 
    borderRadius: '4px', 
    cursor: 'pointer',
    transition: 'background-color 0.3s ease'
  }}
>
  লগইন করুন
</button>
        </form>
      </div>
    </div>
  );
}

export default Login;